<details-section
  title="Messaging"
  [showDetails]="false"
  description="{{
  detailsSectionDescription
  }}"
>
  <div class="textarea-container" [formGroup]="form">
    <div [formGroup]="messagingPromptGroup">
      <qai-field [label]="messagingPromptLabel">
        <textarea
          qai-textarea
          autosize
          [maxLines]="30"
          qaiTrimLeading
          qaiPasteClean
          formControlName="promptText"
        ></textarea>
      </qai-field>
    </div>
  </div>

  <div class="message-theme-container">
    <qai-label [kind]="'secondary'" class="theme-label" [size]="'small'" [weight]="'regular'">
      {{themesLabel}}
    </qai-label>
    <qai-dragable
      [listId]="'themes-list'"
      [items]="themesItems"
      [useDragHandle]="true"
      [dragHandleDisable]="true"
      (itemsChange)="onThemesReordered($event)"
    >
      <ng-template #cardTemplate let-item>
        <div style="display: flex; align-items: flex-start; gap: 8px;">
          <messaging-theme
            style="flex: 1;"
            [messagingFactSection]="asFormGroup(item)"
            [messagingFactSectionFacts]="$any(asFormGroup(item).get('facts'))"
            [messagingFactSections]="messagingFactSections"
            [sectionUuid]="asFormGroup(item).get('uuid')?.value"
            [sectionName]="asFormGroup(item).get('name')?.value"
            [otherThemeListIds]="getOtherThemeListIds(item)"
            (deleteRequested)="handleDeleteTheme($event)"
          ></messaging-theme>
        </div>
      </ng-template>
    </qai-dragable>
  </div>
  <div class="add-theme">
    <button
      qai-button
      [shape]="'normal'"
      [kind]="'tertiary-text'"
      [size]="'medium'"
      [disabled]="readOnly"
      (click)="addTheme($event)"
    >
      <qai-icon kind="plus" size="'20px'" positionStart />
      <span>Add theme</span>
    </button>
  </div>
</details-section>

